export default __webpack_public_path__ + "static/media/ellipse1.19fdd1b0.svg";